// extracted by css-extract-rspack-plugin
export default {"FileInputText":"rVgQz","FileInputPlaceholder":"Eomgi","FileInputSection":"g38wF"};